import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { FormField } from '../../FormField/FormField';
import { RoutineFormFieldProps } from '../types';

type RoutineDescriptionFieldProps = Pick<RoutineFormFieldProps, 'form' | 'setFormFields'> & {
  isEditing: boolean;
  isCreating: boolean;
};

export const RoutineDescriptionField = ({ form, setFormFields, isEditing, isCreating }: RoutineDescriptionFieldProps) => {
  return (
    <FormField className='routine-description-field' elementId='routine-description' labelTitle='Indicaciones' fullWidth>
      {isEditing || isCreating ? (
        <InputTextarea
          id='routine-description'
          autoResize
          value={form?.description}
          onChange={(e) => setFormFields({ description: e.target.value })}
          rows={2}
          placeholder={`Escribe indicaciones sobre la rutina para el usuario`}
        />
      ) : (
        <p>{form?.description}</p>
      )}
    </FormField>
  );
};
